<template>
  <div class="custom-config-form">
    <!-- 步骤条 -->
    <el-steps :active="currentStep" finish-status="success">
      <el-step title="产品信息"></el-step>
      <el-step title="客户资料"></el-step>
      <el-step title="申报信息"></el-step>
    </el-steps>

    <!-- 步骤1: 产品信息 -->
    <div v-show="currentStep === 0" class="step-content">
      <el-form :model="form" label-width="140px">
        <el-form-item label="产品名称：" required>
          <el-autocomplete
            v-model="form.product_name"
            :fetch-suggestions="queryProductSearch"
            placeholder="请输入产品名称"
            :disabled="isView || isEdit"
            @select="handleProductSelect"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div class="step-buttons">
        <el-button type="primary" @click="nextStep(1)">下一步</el-button>
      </div>
    </div>

    <!-- 步骤2: 客户资料 -->
    <div v-show="currentStep === 1" class="step-content">
      <el-form :model="form" label-width="140px">
        <!-- 投保人类型 -->
        <el-form-item label="">
          <el-radio-group v-model="form.pickedP" :disabled="isView">
            <el-radio :label="1">任意投保人</el-radio>
            <el-radio :label="2">绑定投保人</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 任意投保人选项 -->
        <el-form-item v-if="form.pickedP === 1" label="投保人：">
          <el-checkbox v-model="form.p_verify" :disabled="isView">投保人身份验证</el-checkbox>
          <span v-if="form.p_verify" style="margin-left: 20px;">
            <el-checkbox v-model="form.p_type_enterprise" :disabled="isView">企业</el-checkbox>
            <el-checkbox v-model="form.p_type_personal" :disabled="isView">个人</el-checkbox>
          </span>
        </el-form-item>

        <!-- 绑定投保人选项 -->
        <el-form-item v-if="form.pickedP === 2" label="投保人：" class="multi-line">
          <div>
            <el-checkbox v-model="form.p_verify" :disabled="isView">投保人身份验证</el-checkbox>
            <span v-if="form.p_verify" style="margin-left: 20px;">
              <el-checkbox v-model="form.p_type_enterprise" :disabled="isView">企业</el-checkbox>
              <el-checkbox v-model="form.p_type_personal" :disabled="isView">个人</el-checkbox>
            </span>
          </div>
          <div style="margin-top: 10px;">
            <el-checkbox v-model="form.companyS" :disabled="isView">绑定固定公司名称：</el-checkbox>
            <el-input
              v-model="form.fixed_company"
              :disabled="isView || !form.companyS"
              placeholder="请输入固定公司名称"
              style="width: 200px; margin-left: 10px;"
            />
          </div>
        </el-form-item>

        <!-- 被保险人类型 -->
        <el-form-item label="">
          <el-radio-group v-model="form.pickedB" :disabled="isView">
            <el-radio :label="1">任意被保险人</el-radio>
            <el-radio :label="2">同投保人一致</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 任意被保险人选项 -->
        <el-form-item v-if="form.pickedB === 1" label="被保险人：">
          <el-checkbox v-model="form.b_verify" :disabled="isView">控制被保险人类型</el-checkbox>
          <span v-if="form.b_verify" style="margin-left: 20px;">
            <el-checkbox v-model="form.b_type_enterprise" :disabled="isView">企业</el-checkbox>
            <el-checkbox v-model="form.b_type_personal" :disabled="isView">个人</el-checkbox>
          </span>
        </el-form-item>

        <!-- 其他选项 -->
        <el-form-item label="">
          <el-checkbox v-model="form.hidden" :disabled="isView">前端隐藏投保人</el-checkbox>
          <el-checkbox v-model="form.make" :disabled="isView" style="margin-left: 30px;">开票信息</el-checkbox>
        </el-form-item>
      </el-form>
      
      <div class="step-buttons">
        <el-button @click="prevStep">返回上一步</el-button>
        <el-button type="primary" @click="nextStep(2)">下一步</el-button>
      </div>
    </div>

    <!-- 步骤3: 申报信息 -->
    <div v-show="currentStep === 2" class="step-content">
      <div style="padding: 20px 0;">
        <h4>申报信息项:</h4>
        <div class="declare">
          <el-checkbox v-model="form.declares" :disabled="isView">起运地、目的地</el-checkbox>
          <el-checkbox v-model="form.show_info_vehicle" :disabled="isView" style="margin-left: 30px;">车辆信息</el-checkbox>
          <el-checkbox v-model="form.show_info_cargo" :disabled="isView" style="margin-left: 30px;">货物信息</el-checkbox>
        </div>
        
        <div v-if="form.declares" style="margin-top: 20px;">
          <el-radio-group v-model="form.area" :disabled="isView">
            <el-radio :label="1">全国联保</el-radio>
            <el-radio :label="2">设置不保区域</el-radio>
          </el-radio-group>
        </div>

        <!-- 不保区域设置 -->
        <div v-if="form.area === 2 && form.declares" style="margin-top: 20px;">
          <el-button @click="showProvinceDialog" :disabled="isView">设置不保区域</el-button>
          <span v-if="form.limit_insure_provinces" style="margin-left: 10px; color: #666;">
            已选择: {{ form.limit_insure_provinces }}
          </span>
        </div>
      </div>
      
      <div class="step-buttons">
        <el-button @click="prevStep">返回上一步</el-button>
        <el-button v-if="!isView" type="primary" @click="handleSubmit">确认提交</el-button>
        <el-button v-if="isView" @click="handleCancel">关闭</el-button>
      </div>
    </div>

    <!-- 省份选择对话框 -->
    <el-dialog
      title="设置不保区域"
      :visible.sync="provinceDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :append-to-body="true"
      @close="handleProvinceDialogClose"
    >
      <el-table
        ref="provinceTable"
        :data="provinceList"
        @selection-change="handleProvinceSelectionChange"
        height="300px"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="province" label="省份" align="center"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="provinceDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveProvinceSelection">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProductList, saveProductConfig, getProductConfigInfo, getProvinceList } from '@/api/product'

export default {
  name: 'CustomConfigForm',
  props: {
    formData: {
      type: Object,
      default: null
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStep: 0,
      form: {
        id: null,
        product_name: '',
        product_id: null,
        pickedP: 1,
        pickedB: 1,
        p_verify: false,
        b_verify: false,
        p_type_enterprise: false,
        p_type_personal: false,
        b_type_enterprise: false,
        b_type_personal: false,
        companyS: false,
        fixed_company: '',
        hidden: false,
        make: false,
        declares: false,
        area: 1,
        show_info_vehicle: false,
        show_info_cargo: false,
        limit_insure_provinces: ''
      },
      productList: [],
      provinceDialogVisible: false,
      provinceList: [],
      selectedProvinces: [],
      loading: false
    }
  },
  computed: {
    isEdit() {
      return !!this.formData
    }
  },
  mounted() {
    this.fetchProductList()
    this.fetchProvinceList()
    if (this.formData) {
      this.loadFormData()
    }
  },
  methods: {
    // 获取产品列表
    async fetchProductList() {
      try {
        const response = await getProductList()
        if (response && response.err_code === 0) {
          this.productList = response.rows || []
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
      }
    },

    // 获取省份列表
    async fetchProvinceList() {
      try {
        const response = await getProvinceList()
        if (response && response.err_code === 0) {
          this.provinceList = response.rows || []
        }
      } catch (error) {
        console.error('获取省份列表失败:', error)
      }
    },

    // 产品搜索
    queryProductSearch(queryString, cb) {
      const results = queryString
        ? this.productList.filter(item => 
            item.name.toLowerCase().includes(queryString.toLowerCase())
          )
        : this.productList
      cb(results.map(item => ({ value: item.name, id: item.id })))
    },

    // 选择产品
    handleProductSelect(item) {
      this.form.product_id = item.id
    },

    // 加载表单数据
    async loadFormData() {
      if (!this.formData.id) return
      
      try {
        const response = await getProductConfigInfo({ id: this.formData.id })
        if (response && response.err_code === 0) {
          const data = response.data
          this.form.id = data.id
          this.form.product_name = data.product_name
          this.form.product_id = data.product_id

          // 投保人设置
          if (data.is_limit_policyholder === 0) {
            this.form.pickedP = 1
          } else if (data.is_limit_policyholder === 1) {
            this.form.pickedP = 2
            this.form.companyS = false
          } else if (data.is_limit_policyholder === 2) {
            this.form.pickedP = 2
            this.form.companyS = true
            this.form.fixed_company = data.fixed_company || ''
          }

          // 投保人验证
          this.form.p_verify = !!data.is_verify_policyholder
          if (data.verify_policyholder_type === 1) {
            this.form.p_type_enterprise = true
            this.form.p_type_personal = false
          } else if (data.verify_policyholder_type === 2) {
            this.form.p_type_enterprise = false
            this.form.p_type_personal = true
          } else if (data.verify_policyholder_type === 4) {
            this.form.p_type_enterprise = true
            this.form.p_type_personal = true
          }

          // 被保险人设置
          this.form.pickedB = data.is_limit_beneficiary ? 2 : 1
          this.form.b_verify = !!data.is_verify_beneficiary
          if (data.verify_beneficiary_type === 1) {
            this.form.b_type_enterprise = true
            this.form.b_type_personal = false
          } else if (data.verify_beneficiary_type === 2) {
            this.form.b_type_enterprise = false
            this.form.b_type_personal = true
          } else if (data.verify_beneficiary_type === 4) {
            this.form.b_type_enterprise = true
            this.form.b_type_personal = true
          }

          // 其他设置
          this.form.hidden = !!data.is_hide_policyholder
          this.form.make = !!data.is_show_invoice
          this.form.declares = !!data.is_show_route
          this.form.show_info_vehicle = !!data.is_show_plate_info
          this.form.show_info_cargo = !!data.is_show_cargo_info

          // 不保区域
          if (data.limit_insure_provinces) {
            this.form.limit_insure_provinces = data.limit_insure_provinces
            this.form.area = 2
          } else {
            this.form.area = 1
          }
        }
      } catch (error) {
        console.error('加载配置信息失败:', error)
        this.$message.error('加载配置信息失败')
      }
    },

    // 下一步
    nextStep(step) {
      if (step === 1) {
        if (!this.form.product_name) {
          this.$message.warning('请输入产品名称')
          return
        }
        if (!this.form.product_id) {
          this.$message.warning('请选择有效的产品')
          return
        }
      } else if (step === 2) {
        // 验证投保人设置
        if (this.form.pickedP === 2 && this.form.companyS && !this.form.fixed_company) {
          this.$message.warning('请输入固定公司名称')
          return
        }
        if (this.form.p_verify && !this.form.p_type_enterprise && !this.form.p_type_personal) {
          this.$message.warning('请选择投保人类型')
          return
        }
        if (this.form.pickedB === 1 && this.form.b_verify && !this.form.b_type_enterprise && !this.form.b_type_personal) {
          this.$message.warning('请选择被保险人类型')
          return
        }
      }
      
      this.currentStep = step
    },

    // 上一步
    prevStep() {
      if (this.currentStep > 0) {
        this.currentStep--
      }
    },

    // 显示省份选择对话框
    showProvinceDialog() {
      this.provinceDialogVisible = true
      // 使用setTimeout确保对话框完全渲染后再操作表格
      setTimeout(() => {
        if (this.$refs.provinceTable) {
          // 清除之前的选择
          this.$refs.provinceTable.clearSelection()
          // 设置已选择的省份
          if (this.form.limit_insure_provinces) {
            const selectedProvinces = this.form.limit_insure_provinces.split(',')
            this.provinceList.forEach((province) => {
              if (selectedProvinces.includes(province.province)) {
                this.$refs.provinceTable.toggleRowSelection(province, true)
              }
            })
          }
        }
      }, 100)
    },

    // 省份选择变化
    handleProvinceSelectionChange(selection) {
      this.selectedProvinces = selection
    },

    // 保存省份选择
    saveProvinceSelection() {
      const provinceNames = this.selectedProvinces.map(item => item.province)
      this.form.limit_insure_provinces = provinceNames.join(',')
      this.provinceDialogVisible = false
      this.$message.success('保存成功')
    },

    // 处理省份对话框关闭
    handleProvinceDialogClose() {
      this.selectedProvinces = []
    },

    // 提交表单
    async handleSubmit() {
      // 验证申报信息
      if (!this.form.show_info_vehicle && !this.form.show_info_cargo) {
        this.$message.warning('车辆信息和货物信息二选一')
        return
      }

      this.loading = true
      try {
        const data = {
          product_id: this.form.product_id
        }

        if (this.form.id) {
          data.id = this.form.id
        }

        // 投保人设置
        if (this.form.pickedP === 1) {
          data.is_limit_policyholder = 0
        } else if (this.form.pickedP === 2 && this.form.companyS) {
          data.is_limit_policyholder = 2
          data.fixed_company = this.form.fixed_company
        } else if (this.form.pickedP === 2) {
          data.is_limit_policyholder = 1
        }

        // 投保人验证
        data.is_verify_policyholder = this.form.p_verify
        if (this.form.p_verify) {
          if (this.form.p_type_enterprise && this.form.p_type_personal) {
            data.verify_policyholder_type = 4
          } else if (this.form.p_type_enterprise) {
            data.verify_policyholder_type = 1
          } else if (this.form.p_type_personal) {
            data.verify_policyholder_type = 2
          }
        }

        // 被保险人设置
        data.is_limit_beneficiary = this.form.pickedB === 2
        data.is_verify_beneficiary = this.form.b_verify
        if (this.form.b_verify) {
          if (this.form.b_type_enterprise && this.form.b_type_personal) {
            data.verify_beneficiary_type = 4
          } else if (this.form.b_type_enterprise) {
            data.verify_beneficiary_type = 1
          } else if (this.form.b_type_personal) {
            data.verify_beneficiary_type = 2
          }
        }

        // 其他设置
        data.is_hide_policyholder = this.form.hidden
        data.is_show_invoice = this.form.make
        data.is_show_route = this.form.declares
        data.is_show_plate_info = this.form.show_info_vehicle
        data.is_show_cargo_info = this.form.show_info_cargo

        // 不保区域
        if (this.form.declares && this.form.area === 2 && this.form.limit_insure_provinces) {
          data.limit_insure_provinces = this.form.limit_insure_provinces
        }

        const response = await saveProductConfig(data)
        if (response && response.err_code === 0) {
          this.$emit('save', response.data)
        } else {
          this.$message.error(response?.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存配置失败:', error)
        this.$message.error('网络错误，请重试')
      } finally {
        this.loading = false
      }
    },

    // 取消
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.custom-config-form {
  padding: 20px 0;
}

.step-content {
  margin-top: 30px;
  min-height: 300px;
}

.step-buttons {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.step-buttons .el-button {
  margin: 0 10px;
}

.multi-line .el-form-item__content {
  line-height: 1.8;
}

.multi-line .el-form-item__content > div {
  margin-bottom: 10px;
}

.declare {
  padding: 10px 0;
}

.declare .el-checkbox {
  margin-right: 0;
}

h4 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}
</style>